export default __webpack_public_path__ + "static/media/DSC50006.d2f8a638.jpg";